export const withholdingSlipStatuses = [
  { value: 'submitted', label: '提出済み' },
  { value: 'not_submitted', label: '手元にある' },
  { value: 'in_order', label: '取り寄せ中' },
  { value: 'unavailable', label: '入手できない' }
];
